import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Table, Button, Progress, Modal, message, Empty, Tooltip } from "antd";
import styled from "styled-components";
import moment from "moment";

import * as bankReconciliationActions from "../actions";

var Container = styled.div`
    background: #fff;
    border-radius: 8px;
    padding: 20px;
`;

var ImportsList = function() {
    var dispatch = useDispatch();

    var imports = useSelector(function(state) {
        return state.bankReconciliation.imports;
    });

    var data = imports.data || [];
    var isLoading = imports.isLoading;

    useEffect(function() {
        dispatch(bankReconciliationActions.loadImports());
    }, []);

    var handleDelete = function(record) {
        Modal.confirm({
            title: "Excluir importação?",
            content: (
                <div>
                    <p>Você está prestes a excluir a importação <strong>{record.file_name}</strong>.</p>
                    <p>Isso irá remover <strong>{record.statements_count}</strong> lançamento(s) do extrato.</p>
                    <p style={{ color: '#f5222d' }}>Esta ação não pode ser desfeita.</p>
                </div>
            ),
            okText: "Excluir",
            okType: "danger",
            cancelText: "Cancelar",
            onOk: function() {
                dispatch(bankReconciliationActions.deleteImport(record.id))
                    .then(function() {
                        message.success("Importação excluída com sucesso");
                    })
                    .catch(function() {
                        message.error("Erro ao excluir importação");
                    });
            },
        });
    };

    var columns = [
        {
            title: "Data",
            dataIndex: "created_at",
            key: "created_at",
            width: 150,
            render: function(value) {
                return moment(value).format("DD/MM/YYYY HH:mm");
            },
        },
        {
            title: "Arquivo",
            dataIndex: "file_name",
            key: "file_name",
            ellipsis: true,
            render: function(value, record) {
                return (
                    <Tooltip title={record.original_file_name || value}>
                        <span>{value}</span>
                    </Tooltip>
                );
            },
        },
        {
            title: "Importado por",
            dataIndex: "imported_by",
            key: "imported_by",
            width: 180,
            render: function(value, record) {
                if (record.imported_by) {
                    return record.imported_by.name;
                }
                return "-";
            },
        },
        {
            title: "Registros",
            key: "records",
            width: 180,
            render: function(value, record) {
                return (
                    <span>
                        <span style={{ color: '#52c41a' }}>{record.imported_records}</span>
                        {record.skipped_records > 0 && (
                            <span style={{ color: '#faad14' }}> / {record.skipped_records} ignorados</span>
                        )}
                        <span style={{ color: '#8c8c8c' }}> de {record.total_records}</span>
                    </span>
                );
            },
        },
        {
            title: "Progresso",
            key: "progress",
            width: 180,
            render: function(value, record) {
                var pending = record.pending_count || 0;
                var reconciled = record.reconciled_count || 0;
                var total = record.statements_count || 0;
                var percent = total > 0 ? Math.round((reconciled / total) * 100) : 0;

                return (
                    <div>
                        <Progress
                            percent={percent}
                            size="small"
                            status={percent === 100 ? 'success' : 'active'}
                            strokeColor={{
                                '0%': '#52c41a',
                                '100%': '#1890ff',
                            }}
                        />
                        <div style={{ fontSize: 11, color: '#8c8c8c' }}>
                            {reconciled} conciliados / {pending} pendentes
                        </div>
                    </div>
                );
            },
        },
        {
            title: "Ações",
            key: "actions",
            width: 100,
            align: "center",
            render: function(value, record) {
                return (
                    <Button
                        type="danger"
                        icon="delete"
                        size="small"
                        ghost
                        onClick={function() { handleDelete(record); }}
                    />
                );
            },
        },
    ];

    if (data.length === 0 && !isLoading) {
        return (
            <Container>
                <Empty
                    description="Nenhuma importação encontrada"
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                />
            </Container>
        );
    }

    return (
        <Container>
            <Table
                dataSource={data}
                columns={columns}
                rowKey="id"
                loading={isLoading}
                pagination={{
                    pageSize: 10,
                    showSizeChanger: true,
                    showTotal: function(total) {
                        return "Total: " + total + " importação(ões)";
                    },
                }}
            />
        </Container>
    );
};

export default ImportsList;
